export { DictationResultByUserEntity } from './dictation-result-by-user-entity';
export { DictationResultsByUserEntity } from './dictation-results-by-user-entity';
export { DictationResultsByUserEntityList } from './dictation-results-by-user-entity-list';
export { DictationUserEntity } from './dictation-user-entity';
export { DictationUserEntityList } from './dictation-user-entity-list';
export { UserEntity } from './user-entity';

export type { Entity as DictationUserEntityType } from './dictation-user-entity';
